/* Recortes entre seções: a calda derrete com a rolagem.
   A calda é desenhada como líquido de verdade com o filtro "gooey" do SVG: uma faixa, línguas
   de calda (cápsulas) e uma gota na ponta de cada uma passam por desfoque + limiar de alfa, e as
   formas se fundem com as junções côncavas macias da tensão superficial. Desenhado em pixels
   (o viewBox acompanha o tamanho da caixa), então nada estica no celular.
   Com a rolagem o comprimento das línguas vai de 0,45 (recorte entrando por baixo da tela) a
   1,7 (perto do topo); a gota anda um pouco à frente e forma o "pescoço" antes de pingar.
   Descendo a página a calda escorre; subindo, recolhe. No Horizon quem rola no desktop é o
   .page-wrapper, por isso o listener é em captura. O path estático do snippet fica de reserva
   se este script não rodar. */
const NS = 'http://www.w3.org/2000/svg';
const el = (nome, attrs = {}) => { const e = document.createElementNS(NS, nome); for (const k in attrs) e.setAttribute(k, attrs[k]); return e; };
const parado = matchMedia('(prefers-reduced-motion: reduce)').matches;

/* sorteio com semente: a calda sai sempre igual em cada largura */
function sorteio(seed) {
  let s = seed >>> 0;
  return () => { s = (s + 0x6d2b79f5) >>> 0; let t = s; t = Math.imul(t ^ (t >>> 15), t | 1); t ^= t + Math.imul(t ^ (t >>> 7), t | 61); return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };
}

const recortes = [...document.querySelectorAll('.mk-recorte svg[data-pts]')].map((svg, n) => {
  const id = `mk-goo-${n}`;
  const defs = el('defs');
  const filtro = el('filter', { id, filterUnits: 'userSpaceOnUse', 'color-interpolation-filters': 'sRGB' });
  const blur = el('feGaussianBlur', { in: 'SourceGraphic', stdDeviation: '6' });
  filtro.append(blur, el('feColorMatrix', { values: '1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 26 -12' }));
  /* o recorte corta tudo acima do topo da caixa: a faixa começa acima para o desfoque não
     afinar a beirada de cima, mas não pode pintar sobre o fim da seção anterior */
  const corte = el('clipPath', { id: `${id}-c` });
  const corteRet = el('rect', { x: -40, y: 0, width: 1, height: 1 });
  corte.append(corteRet);
  defs.append(filtro, corte);
  const g = el('g', { filter: `url(#${id})`, fill: 'currentColor' });
  const moldura = el('g', { 'clip-path': `url(#${id}-c)` });
  moldura.append(g);
  svg.append(defs, moldura);
  return { svg, caixa: svg.closest('.mk-recorte'), estatico: svg.querySelector('path'), filtro, blur, corteRet, g, seed: 21 + n * 7, w: 0, h: 0, gotas: [], fator: -1 };
});

/* monta faixa, ondas da beirada e línguas para a largura atual */
function monta(r) {
  const w = r.caixa.clientWidth, h = r.caixa.clientHeight;
  if (!w || !h || (w === r.w && h === r.h)) return false;
  r.w = w; r.h = h;
  const u = Math.max(0.55, Math.min(1, w / 1400));   // escala da espessura (celular mais fino)
  const y0 = Math.round(h * 0.32);                   // linha da faixa
  r.svg.setAttribute('viewBox', `0 0 ${w} ${h}`);
  Object.entries({ x: -40, y: -40, width: w + 80, height: h * 5 + 40 }).forEach(([k, v]) => r.filtro.setAttribute(k, v));
  Object.entries({ width: w + 80, height: h * 5 }).forEach(([k, v]) => r.corteRet.setAttribute(k, v));
  r.blur.setAttribute('stdDeviation', (7 * u + 1.5).toFixed(1)); // desfoque = maciez das junções
  r.estatico.style.display = 'none';
  r.g.replaceChildren(el('rect', { x: -40, y: -40, width: w + 80, height: 40 + y0 }));

  const rnd = sorteio(r.seed);
  /* beirada: ondas largas e baixas, para a faixa não ficar uma régua */
  for (let x = -20; x < w + 40;) {
    const passo = (80 + rnd() * 100) * u;           // ondas sobrepostas: sem beliscão entre elas
    r.g.append(el('ellipse', { cx: x, cy: y0, rx: passo * 0.85, ry: (1.5 + rnd() * 3) * u }));
    x += passo;
  }
  /* línguas: espaçamento irregular, larguras e comprimentos variados (muitas curtas, poucas longas) */
  r.gotas = [];
  const alto = h / 64 + 0.35;
  let x = (20 + rnd() * 50) * u;
  while (x < w - 10 * u) {
    const sorte = rnd();
    const larg = (sorte < 0.35 ? 12 + rnd() * 6 : sorte < 0.8 ? 18 + rnd() * 8 : 26 + rnd() * 10) * u;
    const comp = (sorte < 0.35 ? 8 + rnd() * 10 : sorte < 0.8 ? 18 + rnd() * 18 : 34 + rnd() * 26) * u * alto;
    const lingua = el('rect', { x: x - larg / 2, y: y0 - 8, width: larg, rx: larg / 2 });
    const gota = el('circle', { cx: x, r: larg * (0.6 + rnd() * 0.1) });
    r.g.append(lingua, gota);
    r.gotas.push({ y0, larg, comp, lingua, gota, adianta: 0.04 + rnd() * 0.08 });
    x += larg + (26 + rnd() * 80) * u;
  }
  return true;
}

function desenha(r, fator) {
  for (const d of r.gotas) {
    const fim = d.y0 + d.comp * fator;                                  // onde termina a língua
    const ponta = fim + d.comp * d.adianta * Math.max(0, fator - 0.9);  // a gota se adianta quando escorre muito
    d.lingua.setAttribute('height', Math.max(d.larg, fim - d.y0 + 8).toFixed(1));
    d.gota.setAttribute('cy', (ponta - d.larg * 0.55).toFixed(1));
  }
}

if (recortes.length) {
  let animando = false;
  const alvoDe = (b) => {
    if (parado) return 1;
    const p = Math.min(1, Math.max(0, (innerHeight - b.top) / (innerHeight * 0.85)));
    return 0.45 + p * 1.25;
  };
  const passo = () => {
    animando = false;
    const vh = innerHeight;
    for (const r of recortes) {
      const b = r.caixa.getBoundingClientRect();
      if (b.bottom < -300 || b.top > vh + 300) continue;
      const novo = monta(r);
      const alvo = alvoDe(b);
      /* o fator anda suave até o alvo, para o derreter não dar trancos */
      const atual = r.fator < 0 || parado ? alvo : r.fator + (alvo - r.fator) * 0.14;
      if (novo || Math.abs(atual - r.fator) > 0.002) { r.fator = atual; desenha(r, atual); if (!parado) animando = true; }
    }
    if (animando) requestAnimationFrame(passo);
  };
  const pede = () => { if (!animando) { animando = true; requestAnimationFrame(passo); } };
  document.addEventListener('scroll', pede, { passive: true, capture: true });
  addEventListener('resize', pede);
  pede();
}
